import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { OrderHistoryModule } from '../../../../modules/support/manage-user/order-history';

const orderSearchSchema = z.object({
  orderId: z.number().optional(),
  userId: z.string().optional(),
  page: z.number().optional(),
  perPage: z.number().optional(),
  orderStatus: z.string().optional(),
  orderType: z.string().optional(),
  createdAt: z.string().optional(),
  searchText: z.string().optional(),
});
export const Route = createFileRoute(
  '/dashboard/support/manage-user/order-history'
)({
  validateSearch: orderSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <OrderHistoryModule />;
}
